"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsBase = require("js-base64");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// author: Sincere
var DaishuCustomerService = /*#__PURE__*/function () {
  function DaishuCustomerService(_ref) {
    var options = _ref.options,
        onTap = _ref.onTap;

    _classCallCheck(this, DaishuCustomerService);

    // 单例
    if (!DaishuCustomerService.instance) {
      this.options = options;
      this.onTap = onTap;
      this.init();
      DaishuCustomerService.instance = this;
    }

    return DaishuCustomerService.instance;
  }

  _createClass(DaishuCustomerService, [{
    key: "init",
    value: function init() {
      this.getEVN();
      this.appendCss();
      this.appendHtml();
    } // 获取前缀

  }, {
    key: "getEVN",
    value: function getEVN() {
      if (this.options.appPath) {
        this.appPath = this.options.appPath;
        return;
      }

      this.appPath = window.location.href.indexOf("test.") === -1 ? "https://apps.dsjkyy.com/" : "https://test.daishutijian.com/tijian5/apps/";
    }
  }, {
    key: "appendCss",
    value: function appendCss() {
      var styleElement = document.createElement('style');
      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode("div.daishu-customer-service div.customer-service-123{ \n            width: 68px;\n            position: fixed;\n            padding: 5px 8px;\n            border-radius: 100px 0px 0px 100px;\n            text-align: center;\n            box-sizing: border-box;\n            color: #fff;\n            top: 90vh;\n            right: 0;\n            font-size: 16px;\n            align-items: center;\n            -webkit-align-items: center;\n            display: flex;\n            display: -webkit-flex;\n            background-color: ".concat(this.options.style && this.options.style.color ? this.options.style.color : '#4282FE', ";\n            z-index: 1000;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n         }\n         div.daishu-customer-service div.customer-service-123 img{\n            width: 24px;\n            height: 24px;\n         }\n         div.daishu-customer-service div.customer-service-123 p{\n            font-size: 12px;\n            color: #fff;\n            margin: 0;\n            padding: 0;\n            line-height: 13px;\n         }\n         .hide-iframe {\n            animation: iframehide 0.4s ease forwards;\n         }\n          @keyframes iframehide {\n            from {\n              height: 600px;\n            }\n            to {\n              height: 60px;\n            }\n          }\n          @-moz-keyframes iframehide /* Firefox */ {\n            from {\n              height: 600px;\n            }\n            to {\n              height: 60px;\n            }\n          }\n          @-webkit-keyframes iframehide /* Safari \u548C Chrome */ {\n            from {\n              height: 600px;\n            }\n            to {\n              height: 60px;\n            }\n          }\n          @-o-keyframes iframehide /* Opera */ {\n            from {\n              height: 600px;\n            }\n            to {\n              height: 60px;\n            }\n          }\n         ")));
      styleElement.appendChild(frag);
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
  }, {
    key: "appendHtml",
    value: function appendHtml() {
      var _this = this;

      var div = document.createElement('div');
      div.setAttribute('class', 'daishu-customer-service');
      div.setAttribute('id', 'daishu-customer-service');
      var html = "\n            <div class=\"customer-service-123\">\n                <img src=\"".concat(this.appPath, "wechat/resource/images/frontend/customer_service.png?v=123\" />\n                <p>").concat(this.options.style && this.options.style.text ? this.options.style.text : '在线客服', "</p>\n            </div>\n        ");
      div.onclick = this.onTap;
      div.innerHTML = html;
      document.body.appendChild(div);
      this.dom = document.getElementById("daishu-customer-service");
      this.domChild = document.getElementsByClassName("customer-service-123")[0]; // 绑定手指拖动事件

      this.domChild.addEventListener('touchstart', function (e) {
        _this.clientH = document.documentElement.clientHeight;
      }, false);
      this.domChild.addEventListener('touchmove', function (e) {
        e.preventDefault(); // console.log('touchmove', e)

        if (e.changedTouches[0].clientY > _this.clientH - 30 || e.changedTouches[0].clientY < 0) return;
        _this.domChild.style.top = e.changedTouches[0].clientY + 'px';
      }, false);
    } // 恢复

  }, {
    key: "reStar",
    value: function reStar() {
      this.dom.remove();
      this.init();
    } // 自己设置样式

  }, {
    key: "setHtml",
    value: function setHtml(html) {
      this.dom.innerHTML = html;
    } // 跳转

  }, {
    key: "link",
    value: function link() {
      this.open();
    } // 打开客服窗口

  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      this.options.host = window.location.host;

      var options = _jsBase.Base64.encode(JSON.stringify(this.options)); // 判断是否要跳到pc端客服


      switch (this.options.web_type) {
        case 'pc':
          window.open("".concat(this.appPath, "frontend/web-customer-service/h5/index.html#/?options=").concat(options));

        case 'popup':
          if (this.iframe) {
            // 先通知iframe展开
            this.iframe.contentWindow.postMessage('show', '*'); // 展开

            this.iframe.classList.remove("hide-iframe");
            return;
          }

          var div = document.createElement('div');
          var iframe = "\n                <iframe id=\"myIframe\" style=\"width: 500px; height: 565px; bottom: 10px; right: 0px; position: fixed; z-index: 100;\" src=\"".concat(this.appPath, "frontend/web-customer-service/h5/index.html#/?options=").concat(options, "\" frameborder=\"0\"></iframe>\n                ");
          div.innerHTML = iframe;
          document.body.appendChild(div);
          this.iframe = document.getElementById('myIframe');
          window.addEventListener('message', function (event) {
            switch (event.data) {
              case 'hide':
                document.getElementById('myIframe').classList.add("hide-iframe");
                break;

              case 'show':
                document.getElementById('myIframe').classList.remove("hide-iframe");
                break;

              case 'close':
                _this2.iframe.parentNode.removeChild(_this2.iframe);

                _this2.iframe = null;
                break;

              default:
                break;
            }
          }, false);
          break;

        default:
          window.location.href = "".concat(this.appPath, "frontend/h5-customer-service/h5/index.html#/msg?options=").concat(options);
      }
    } // 设置参数

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread(_objectSpread({}, this.options), options);
    } // 隐藏

  }, {
    key: "hide",
    value: function hide() {
      this.dom.style.display = "none";
    } // 显示

  }, {
    key: "show",
    value: function show() {
      this.dom.style.display = "block";
    }
  }]);

  return DaishuCustomerService;
}();

var _default = DaishuCustomerService;
exports["default"] = _default;